/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".attach-image[_ngcontent-%COMP%]{background-repeat:no-repeat;background-position:center;position:relative;width:100%;padding-top:100%;border:1px solid #c4bbbb}.attach-image[_ngcontent-%COMP%]   .btn-delete[_ngcontent-%COMP%]{position:absolute;right:5px;top:5px;cursor:pointer;color:red}"];
export { styles as styles };
